module.exports = __webpack_public_path__ + "img/remixicon.9ab8a5e1.svg";